import React from "react";
import {
  isCompletedPickup,
  isFuturePickup,
  isMissedPickup,
  isNewPickup,
  isNotCompletedPickup,
  isUnAcknowledgedPickup,
  isNoFreightPickup,
  isToBeReviewedPickup,
  isUnprocessedPickup,
} from "../filterUtils";
import {
  MissedPickupMarker,
  DailyPickupMarker,
  FutureMarker,
  UnacknowledgedMarker,
  VoidedMarker,
  UnassignedPickupsMarker,
  CompletedMarker,
  NotCompletedMarker,
  NewPickUpIcon,
  NoFreightMarker,
  MarkerWithBadge,
  UnProcessMarker,
} from "../../../../mapComponents/Markers";
import { PICKUP_STATUS } from "../constants";
import { getUnassignMarkerInfo } from "../DriverMap/utils";

export const getPickupStatus = ({pickup, terminalOffset, newPickupDuration}) => {
  if (isToBeReviewedPickup({pickup})) {
    return PICKUP_STATUS.toBeReviewed;
  }
  
  if (pickup.isVoided) {
    return PICKUP_STATUS.voided;
  }

  if (isFuturePickup(pickup.pickupDate, terminalOffset)) {
    return PICKUP_STATUS.future;
  }

  if (isNoFreightPickup({pickup})) {
    return PICKUP_STATUS.noFreight;
  }

  if (isCompletedPickup({pickup, terminalOffset})) {
    return PICKUP_STATUS.completed;
  }

  if (isMissedPickup({pickup})) {
    return PICKUP_STATUS.missed;
  }

  if (isUnAcknowledgedPickup({pickup, terminalOffset})) {
    return PICKUP_STATUS.unacknowledged;
  }

  if (isNotCompletedPickup({pickup, terminalOffset})) {
    return PICKUP_STATUS.notCompleted;
  }

  if (isNewPickup({pickup, terminalOffset, newPickupDuration})) {
    return PICKUP_STATUS.newPickup;
  }

  if (isUnprocessedPickup({pickup})) {
    return PICKUP_STATUS.unprocessed;
  }

  if (pickup.isDailyPickup) {
    return PICKUP_STATUS.dailyPickup;
  } 
  return PICKUP_STATUS.unassigned;
};

const getDefaultBackgroundColor = (status, theme) => {
  switch (status) {
    case PICKUP_STATUS.newPickup:
      return theme.newPickupFillColor;
    case PICKUP_STATUS.voided:
    case PICKUP_STATUS.missed:
      return theme.missedVoidedPickupFillColor;
    case PICKUP_STATUS.noFreight:
    case PICKUP_STATUS.completed:
    case PICKUP_STATUS.unacknowledged:
    case PICKUP_STATUS.notCompleted:
      return theme.pickupStatusFillColors;
    case PICKUP_STATUS.toBeReviewed:
      return theme.iconColor;
    default:
      return theme.unassignPickupFillColor;
  }
};

export const getPickupStatusTypeIcon = ({
  isActive,
  theme,
  size = 20,
  status,
  badgeContent
}) => {
  let [backgroundColor, borderColor] = [null, null];
  if (isActive) {
    ({backgroundColor, borderColor} = getUnassignMarkerInfo({isActive, theme, pickupStatus: status}));
  }
  const markerComponents = {
    [PICKUP_STATUS.newPickup]: NewPickUpIcon,
    [PICKUP_STATUS.noFreight]: NoFreightMarker,
    [PICKUP_STATUS.completed]: CompletedMarker,
    [PICKUP_STATUS.voided]: VoidedMarker,
    [PICKUP_STATUS.unacknowledged]: UnacknowledgedMarker,
    [PICKUP_STATUS.future]: FutureMarker,
    [PICKUP_STATUS.notCompleted]: NotCompletedMarker,
    [PICKUP_STATUS.missed]: MissedPickupMarker,
    [PICKUP_STATUS.dailyPickup]: DailyPickupMarker,
    [PICKUP_STATUS.unprocessed]: UnProcessMarker,
  };

  const MarkerComponent = markerComponents[status] || UnassignedPickupsMarker;
  return (
    <MarkerWithBadge
      MarkerComponent={MarkerComponent}
      size={size}
      backgroundColor={backgroundColor || getDefaultBackgroundColor(status, theme)}
      borderColor={borderColor || theme.markerStokeColor}
      badgeContent={badgeContent}
    />
  );
};
